import type { IconData } from '@stacksjs/iconify-core'

export const chevronTop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M398.986 424.715L256 281.73L113.014 424.715l-97.17-97.169L158.8 184.59l11.29-11.4L256 87.285l5.481 5.531l5.89 5.834l85.907 85.908l-.054.054l142.932 142.934ZM61.1 327.546l51.915 51.915L256 236.474l142.986 142.987l51.914-51.915l-143.037-143.038l.054-.053l-51.812-51.813l-.051.051l-.1-.106l-51.866 51.869l-11.312 11.418Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default chevronTop
